export const scrollTop = () => {
  if (document.documentElement) {
    document.documentElement.scrollTop = 0;
  }
};
